import React from 'react';
import * as UIcons from '@iconscout/react-unicons';
import { useSelector, useDispatch } from 'react-redux';
import { previewModal } from 'store/slices/miscSlice';

export default function PreviewModal() {
  const { previewModal: {state, data} } = useSelector(state => state.misc);
  const dispatch = useDispatch();

  const Content = data?.content;
  const Title = data?.title;

  return (
    <>
      {
        !state ? (
          <></>
        ) : (
          <div className={`bg-black fixed inset-0 bg-opacity-30 flex items-center justify-center z-50 p-4`} onClick={() => dispatch(previewModal('close'))}>
            <div className="lg:max-w-md rounded-xl lg:w-full w-11/12 bg-white text-placeholder max-h-[90vh] flex flex-col overflow-hidden" onClick={(e) => e.stopPropagation()}>
              <div className="relative p-3 shrink-0">
                {
                  typeof(Title) === 'string' ? (
                    <h3 className="text-xl text-center text-secondary font-semibold w-full">{data?.title}</h3>
                  ) : (
                    <Title />
                  )
                }

                <UIcons.UilTimes
                  className="absolute top-2 right-2 text-placeholder text-3xl cursor-pointer"
                  onClick={() => dispatch(previewModal('close'))}
                />
              </div>

              <ul className="overflow-y-auto pb-5">
                <Content />
              </ul>
            </div>
          </div>
        )
      }
    </>
  )
}
